import { AspectRatio } from '../../AspectRatio';

import styles from './ArticleModuleError.module.scss';
import sectionStyles from './SectionStyles.module.scss';

export function ArticleModuleError() {
	return (
		<AspectRatio>
			<div className={`${styles.wrapper} ${sectionStyles.section}`}>
				<h3>Hier ist etwas schief gelaufen</h3>

				<p className="body3">Bitte entschuldigen Sie die Störung. Versuchen sie es zu einem anderen Zeitpunkt nocheinmal.</p>
			</div>
		</AspectRatio>
	);
}
